define('app',['jquery', "modules/database", 'toastr'], function($, Database, toastr) {
    //Serialize form fields into and object
    var defaultImage = "data:image/png;base64,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";

    $.fn.serializeObject = function(options) {
        var o = {};
        var elements;

        options = options || {};
        if(options.name) {
            elements = this.find('[name="' + options.name + '"]');
        }
        else {
            elements = this.find('[name]').add(this.filter('[name]'));
        }
        if(options.ignore) {
            elements = elements.not($(options.ignore).find('[name]').add(options.ignore));
        }

        elements.filter(function(){
            var type = this.type;
            return !$(this).is(":disabled") &&
                /^(?:input|select|textarea|keygen)/i.test(this.nodeName) &&
                !/^(?:submit|button|image|reset|file)$/i.test(type) &&
                (this.checked || !/^(?:checkbox|radio)$/i.test(type));
        }).each(function(i, elem) {
            var val = $(this).val();
            if(val != null) {
                if($.isArray(val)) {
                    val = val.map(function(v){
                        return v.replace(/\r?\n/g,"\r\n") || '';
                    });
                }
                else {
                    val = val.replace(/\r?\n/g,"\r\n") || '';
                }
                if (o[this.name] !== undefined) {
                    o[this.name] = [].concat(o[this.name], val);
                } else {
                    o[this.name] = val;
                    if($(this).is('select[multiple],[type=checkbox]')) {
                        o[this.name] = [].concat(o[this.name]);
                    }
                }
            }
        }).filter('select[multiple],[type=checkbox]').each(function () {
            if (typeof o[this.name] == 'undefined') {
                o[this.name] = "";
            }
        });
        return options.name ? o[options.name] : o;
    };

    //Fill form with data passed
    $.fn.fill = function(data) {
        var that = this;
        this.reset();
        $.each(data, function(key, value) {
            var field = that.find('[name=' + key + ']');
            if (field.length) {
                if(field.eq(0).is('[type=checkbox],[type=radio]')) {
                    field.prop('checked', false);
                    value = [].concat(value);
                    value.forEach(function(v){
                        field.filter('[value="'+v+'"]').prop('checked', true).trigger('change');
                    });
                } else {
                    field.val(value).trigger('change');
                }
            }
        });
        return this;
    };

    //Reset form
    $.fn.reset = function() {
        return this.find('[name]').each(function () {
            var field = $(this).closest('.field,.form-group');
            var defaultValue = field.data('default') || '';
            if(this.type == 'radio' || this.type == 'checkbox') {
                if(field.length && defaultValue == this.value) {
                    this.checked = true;
                    $(this).trigger('change');
                } else {
                    this.checked = false;
                }
            } else {
                $(this).val(defaultValue).trigger('change');
            }
        }).end();
    };

    jQuery.expr[":"].icontains = jQuery.expr.createPseudo(function(arg) {
        return function( elem ) {
            return jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
        };
    });

    Array.prototype.removeByValue = function() {
        var what, a = arguments, L = a.length, ax;
        while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
                this.splice(ax, 1);
            }
        }
        return this;
    };

    //toastr options
    toastr.options = {
        "newestOnTop": false,
        "positionClass": "toast-top-right",
        "showDuration": "400",
        "hideDuration": "1000",
        "timeOut": "7000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    //Ajax shell
    function zjax(url, data, success, error, logout) {
        var options = {
            url: url,
            data: data,
            success: success,
            error: error,
            logout : logout,
            method: "POST",
            dataType: 'json'
        };

        if (typeof url != 'string') {
            options = url;
        } else {
            if (typeof data == 'function') {
                options.data = {};
                options.success = data;
                options.error = success;
                options.logout = error;
            } else if(!data) {
                options.data = {};
            }
        }

        options.data.api = options.url;
        options.url = '/auth';
        return $.ajax(getRequest(options));
    }

    function getRequest(options) {
        var success = options.success ? options.success : $.noop;
        var error = options.error ? options.error : $.noop;
        var onLogin = options.logout ? options.logout : undefined;
        var logout = function() {
            if(typeof onLogin == 'object') {
                onLogin.onLogout();
            } else {
                App.page.login({
                    message : 'Your session has expired',
                    onLogin : onLogin,
                });
            }
        };

        delete options.success;
        delete options.error;
        delete options.logout;

        options.success = function (response, status, jqXHR) {
            var tstatus = (response.status || 'success').toLowerCase();
            if(tstatus == "error") {
                if (response.message == 'Unauthorized') {
                    logout();
                } else {
                    error(response.message || "Oops!! Something is not right..");
                }
            } else if (tstatus == 'success') {
                success(typeof response.data!=="undefined" ? response.data : response, status, jqXHR);
            }
        };

        options.error = function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status == 401) {
                logout();
            }
        };

        return options;
    }

    //Months reference
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    //Templating
    var templateCache = {};
    function getContent(str, data) {
        // Figure out if we're getting a template, or if we need to
        // load the template - and be sure to cache the result.
        var fn = !/\W/.test(str) ?
                templateCache[str] = templateCache[str] ||
                getContent(document.getElementById(str).innerHTML) :
                // Generate a reusable function that will serve as a template
                // generator (and which will be cached).
                new Function("data",
                        "var App = this;var p=[],print=function(){p.push.apply(p,arguments);};" +
                        // Introduce the data as local variables using with(){}
                        "with(data){p.push('" +
                        // Convert the template into pure JavaScript
                        str
                        .replace(/[\r\t\n]/g, " ")
                        .split("<%").join("\t")
                        .replace(/((^|%>)[^\t]*)'/g, "$1\r")
                        .replace(/\t=(.*?)%>/g, "',$1,'")
                        .split("\t").join("');")
                        .split("%>").join("p.push('")
                        .split("\r").join("\\'")
                        + "');}return p.join('');");

        // Provide some basic currying to the user
        fn = fn.bind(App);
        return data ? fn(data) : fn;
    }


    var commonPages = ['login', 'spinner', 'message', 'map'];
    function getPageModule(name, callback) {
        var module = 'pages/' + (commonPages.indexOf(name) > -1 ? '' : App.module + '/') + name;
        require([module], callback);
    }

    function getPageContent(name, data, callback) {
        var module = 'text!templates/' + (commonPages.indexOf(name) > -1 ? '' : App.module + '/') + name + '.html';
        require([module], function(content) {
            callback(content ? getContent(content, data || {}) : content);
        });
    }

    var page = {
        current : null,
        stack : [],
    };
    var appCache = {};
    var App = {
        module : null,
        page : {
            onInit : null,
            init : function(name, data, element) {
                if(App.module == 'main') {
                    $('#app img').on('error', function() {
                        var $that = $(this);
                        var width = $that.width();
                        if(!!$that.hasClass('image')) {
                            $that.attr('src', defaultImage);
                            $that.css({width : width, height: 'auto'});
                        }
                        else {
                            $that.attr('src', '');
                        }
                    });
                }
                var that = this;
                getPageModule(name, function(pageModule) {
                    var showFooter = 'undefined' == typeof(pageModule.footer) ? null : pageModule.footer;
                    if(typeof showFooter == 'function') {
                        showFooter = showFooter(data);
                    }

                    if(showFooter) {
                        $('body').removeClass('no-footer');
                    } else if(showFooter != null) {
                        $('body').addClass('no-footer');
                    }

                    that.onInit(pageModule, data);
                    pageModule.init.bind(element)(data);
                });
            },
            append : function(name, data, container) {
                var that = this;
                var element = $('#' + name);
                if(!element.length) {
                    if(container) {
                        if(container.hasClass(name)) {
                            element = container;
                        } else {
                            element = $('<div class="' + name + '"></div>');
                            container.append(element);
                        }
                    } else {
                        throw "Container in which generated content should be appended must be passed to page.append method";
                    }
                }

                getPageContent(name, data, function(content) {
                    var regex = /\(\(.*?\.svg\)\)/g;
                    if(!!regex.test(content)) {
                        var htmlContent = content;
                        var imagesInContent = htmlContent.match(/\(\(.*?\.svg\)\)/g);
                        var promiseList = [];
                        if(name == 'products') {
                            var imageName = imagesInContent[0].match(/icons\/.*?\.svg/g)[0].replace('/', '-').replace(/icons-/, 'icon-');
                            App.database.get(imageName, function(data) {
                                var regexExp = new RegExp('\\(\\(.*?'+ imageName.split('-')[1] +'\\)\\)', 'g');
                                htmlContent = htmlContent.replace(regexExp, data);
                            })
                            .then(function() {
                                element.empty().append($(htmlContent));
                                that.init(name, data, element);
                            }, function(error) {
                                element.empty().append($(htmlContent));
                                that.init(name, data, element);
                            });
                        }
                        else {
                            promiseList = imagesInContent.map(function(image) {
                                var imageName = image.match(/icons\/.*?\.svg/g)[0].replace('/', '-').replace(/icons-/, 'icon-');
                                return App.database.get(imageName, function(data) {
                                        var regexExp = new RegExp('\\(\\(.*'+ imageName.split('-')[1] +'\\)\\)', 'g');
                                        htmlContent = htmlContent.replace(regexExp, data);
                                    });
                            });
                            Promise.all(promiseList).then(function() {
                                element.empty().append($(htmlContent));
                                that.init(name, data, element);
                            }, function(error) {
                                element.empty().append($(htmlContent));
                                that.init(name, data, element);
                            });
                        }
                    }
                    else {
                        element.empty().append($(content));
                        that.init(name, data, element);
                    }
                });

                return element;
            },
            render : function(name, data, ignore) {
                var that = this;
                if(page.current) {
                    getPageModule(page.current.name, function(pageModule) {
                        if (pageModule.exit) {
                            page.current.data = pageModule.exit(page.current.data);
                        }
                        process();
                    });
                } else {
                    process();
                }

                function process() {
                    if(typeof name !== 'string') {
                        ignore = data;
                        data = name.data;
                        name = name.name;
                    } else if(page.current) {
                        page.stack.push(page.current);
                    }
                    if(name == 'home') {
                        page.stack = [];
                    }

                    if(page.stack.length == 0) {
                        $('#btn-back').addClass('hidden');
                    }
                    else {
                        $('#btn-back').removeClass('hidden');
                    }

                    if(!ignore) {
                        ignore = ['login', 'spinner', 'message', 'settings'].indexOf(name) > -1;
                    }
                    $('#app').html('<div id="' + name + '" class="page full"></div>');
                    that.append(name, data);
                    page.current = ignore ? null : {name : name, data : data};
                }
            },
            back : function() {
                if(page.stack.length) {
                    this.render(page.stack.pop());
                }
            },
            resetHistory : function() {
                page.stack = [];
                page.current = null;
            },
            login : function(options) {
                this.render('login', options, true);
            }
        },
        api : {
            call : zjax
        },
        notify : function(type, message) {
            return toastr[type](message);
        },
        global : function(key, value) {
            //If key is clearAllExcept, clear all cache except given keys
            if(key == 'clearAllExcept' || key == 'clear') {
                value = [].concat(value);
                if(key == 'clear') {
                    value = [];
                }

                var t = {};
                value.forEach(function(k){
                    t[k] = appCache[k];
                });

                appCache = {};
                $.extend(appCache, t);
                return;
            }

            //If no params sent, return deepCopy of cache object
            if(!key) {
                return $.extend(true, {}, appCache);
            }

            //If key is object overwrite appCache with key
            if(typeof key == 'object') {
                $.extend(appCache, key);
                return key;
            }

            //Normal case, if value is null get else set
            if(typeof value != 'undefined') {
                appCache[key] = value;
            }
            return appCache[key];
        },
        database : null,
        idleTimer : {
            timer : null,
            clear : function() {
                this.timer && clearTimeout(this.timer);
            },
            handler : function(e) {
                App.idleTimer.clear();
                App.idleTimer.timer = setTimeout(function() {
                    App.page.resetHistory();
                    App.page.render('home');
                }, 5*60*1000);
            },
            start : function(callback, idleTime) {
                this.handler();
                $(document).on("mousedown touchstart keydown", this.handler);
            },
            stop : function() {
                this.clear();
                $(document).off("mousedown touchstart keydown", this.handler);
            }
        },
        utils : {
            queue : function(callback, delay) {
                return setTimeout(function() {
                    callback();
                },delay||1);
            },
            debounce: function (func, wait, immediate) {
                var timeout;
                return function () {
                    var context = this, args = arguments;
                    var later = function () {
                        timeout = null;
                        if (!immediate)
                            func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow)
                        func.apply(context, args);
                };
            },
            transpose: function(matrix) {
                var output = [];
                var vLength = matrix.length;
                var hLength = matrix[0].length;

                for(i = 0; i < hLength; i++){
                    output.push([]);
                }

                for(i = 0; i < vLength; i++){
                    for(var j = 0; j < hLength; j++){
                        output[j].push(matrix[i][j]);
                    }
                }
                return output;
            },
            capitalize : function (str) {
                return str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase();
            },
            getOffsetFromEvent : function(e, boundRect) {
                boundRect = typeof boundRect.top != 'undefined' ? boundRect : boundRect.getBoundingClientRect();

                //get the event object which has clientX and clientY information
                if(/touch/i.test(e.type)) {
                    //Event has touch information
                    if(e.touches != null && e.touches.length) {
                        e = e.touches[0];
                    }
                    //If modified event get original event
                    else if(e.originalEvent != null && e.originalEvent.touches.length) {
                        e = e.originalEvent.touches[0];
                    }
                    //If touchend get the required info from changedTouches
                    else if(e.changedTouches != null && e.changedTouches.length) {
                        e = e.changedTouches[0];
                    }
                } else if(e.clientX == null && e.originalEvent != null) {
                    e = e.originalEvent;
                }
                return {
                    x : e.clientX - boundRect.left,
                    y : e.clientY - boundRect.top
                };
            },
            getId : function(str) {
                return str.toString().replace(/[\W_]+/g,"").toLowerCase();
            },
            deleteKeys : function(obj, array) {
                array.forEach(function(key){
                    delete obj[key];
                });
            },
            getNumberSuffix: function (number) {
                if (number >= 11 && number <= 13) {
                    return "th";
                }
                switch (number % 10) {
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th";
                }
            },
            date: {
                formatDate: function (date) {
                    if (!date)
                        return '';
                    if (typeof date === 'string') {
                        date = date.replace(/-/g, "/");
                    }
                    date = new Date(date);
                    var day = date.getDate();
                    if (!day)
                        return 'Invalid Date';
                    day += this.getDayOfMonthSuffix(day);
                    return day + ' ' + months[12 + date.getMonth()] + ' ' + date.getFullYear();
                },
                formatTime: function (date, show12) {
                    if (!date)
                        return '';
                    if (typeof date === 'string') {
                        date = date.replace(/-/g, "/");
                    }
                    date = new Date(date);
                    var hr = date.getHours();
                    var min = date.getMinutes();
                    var hr1;
                    if (hr < 10)
                        hr = '0' + hr;
                    if (min < 10)
                        min = '0' + min;
                    if (hr === 0)
                        hr1 = 12;
                    else if (hr == 12)
                        hr1 = 12;
                    else if (hr > 12) {
                        hr1 = hr - 12;
                        if (hr1 < 10)
                           hr1 = '0' + hr1;
                    }
                    else
                        hr1 = hr;
                    return !show12 ? (hr + ":" + min) : (hr < 12) ? hr1 + ':' + min + ' AM' : hr1 + ':' + min + ' PM';
                },
                formatDateTime: function (date) {
                    if (typeof date === 'string') {
                        date = date.replace(/-/g, "/");
                    }
                    return this.formatDate(date) + ', ' + this.formatTime(date);
                },
                getDayOfMonthSuffix: function (day) {
                    if (day >= 11 && day <= 13) {
                        return "th";
                    }
                    switch (day % 10) {
                        case 1:
                            return "st";
                        case 2:
                            return "nd";
                        case 3:
                            return "rd";
                        default:
                            return "th";
                    }
                },
                pad: function (x) {
                    return ((x < 10) ? '0' : '') + x;
                }
            }
        },
        button : function(element) {
            element = $(element);
            var that = format(element);
            var defaultValue = '';

            function format(button) {
                if(button.is('form')) {
                    button = button.find('button[type=submit]').eq(0);
                    if(!button.length) return false;
                }

                button.addClass('btn-ajax');
                if(!button.find('.btn-ajax-label').length) {
                    button.html('<span class="btn-ajax-label">'+ button.html() +'</span>');
                }

                if(!button.find('.btn-ajax-spinner').length) {
                    var appender = button.hasClass('zoomout') ? button : button.find('.btn-ajax-label');
                    appender.append($('<div class="btn-ajax-spinner"><div></div></div>'));
                }

                return button;
            }
            return {
                load : function() {
                    if(!that) return;
                    App.utils.queue(function() {
                        that.prop('disabled',true);
                        that.addClass('loading');
                    });
                    return this;
                },
                reset : function() {
                    if(!that) return;
                    App.utils.queue(function() {
                        defaultValue && that.html(defaultValue);
                        that.prop('disabled',false);
                        that.removeClass('loading');
                    });
                    return this;
                },
                textContent : function(text) {
                    if(!that) return;
                    if(!defaultValue) {
                        defaultValue = that.html();
                    }
                    that.html(text);
                    format(that);
                    return this;
                }
            };
        },
        bindEvents : function(eventHash, context, delegate) {
            context = context || $(document);
            $.each(eventHash, function(event, handler) {
                event = event.split(':').map($.trim);
                if(delegate) {
                    context.on(event[1],event[0],handler);
                } else {
                    if(event.length == 2) {
                        context.find(event[0]).on(event[1], handler);
                    } else {
                        context.on(event[0], handler);
                    }
                }
            });
        },
        init: function(module, options) {
            options = options || {};
            App.module = module;
            $('body').addClass(module);

            //Update databse set method to update global cache
            App.database = Database(options.tables);
            var _set  = App.database.set.bind(App.database);
            App.database.set = function(key, value, noCache) {
                var output = _set(key, value);
                if(!noCache) {
                    App.global(output.cache);
                }
                return output.promise;
            };

            options.menu = options.menu || [];
            options.menu.forEach(function(menu){
                var url = '';
                if(menu.url) {
                    url = 'href="' + menu.url +'"';
                }
                var menuItem = $('<li><a ' + url + '><i class="fa fa-' + menu.icon + ' fa-fw m-r-xs"></i>' + menu.name + '</a></li>');
                $('#pageMenu').append(menuItem);
                menuItem.click(menu.handler || $.noop);
            });
            App.page.onInit  = (options.onPageInit || $.noop).bind(options);
            App.onLogin = (options.onLogin || $.noop).bind(options);
            App.onRetailerChange = (options.onRetailerChange || $.noop).bind(options);
            App.init = null;
        }
    };

    return App;
});
